import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { JsonPatchOperation } from '@/shared/types/common';

import type { GlossaryTermDetail } from './glossaryTermDetailApi';

type UpdateGlossaryTermRequest = {
  termId: string;
  operations: JsonPatchOperation[];
};

export const updateGlossaryTermApi = async ({
  termId,
  operations,
}: UpdateGlossaryTermRequest): Promise<GlossaryTermDetail> => {
  try {
    const { data } = await openMetadataApiClient.patch<GlossaryTermDetail>(`/glossaryTerms/${termId}`, operations, {
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
    });
    return data;
  } catch (error) {
    console.error('Failed to update glossary term:', error);
    throw error;
  }
};

export type { UpdateGlossaryTermRequest };
